<template>
  <div class="rich_media_area_primary_inner">
    <div id="img-content" class="rich_media_wrp">
      <h2 class="zhemo" id="activity-name">
        价值投资首先要考虑价值，而不是价格
      </h2>
      <!-- <div id="meta_content" class="rich_media_meta_list">
        <span class="rich_media_meta rich_media_meta_text"> 刘建位 </span>
        <em id="publish_time" class="rich_media_meta rich_media_meta_text"
          >4月29日</em
        >
      </div> -->

      <div
        id="js_tags"
        class="article-tag__list"
        style="display: none"
        data-len="0"
      >
        <div class="article-tag-card__title">收录于话题</div>
        <div class="article-tags"></div>
      </div>

      <div
        class="rich_media_content"
        id="js_content"
        style="visibility: visible"
      >

        <p style="">
          <span style="font-size: 15px; letter-spacing: 2px"
            >我最近两年，读了三遍格雷厄姆与多徳的《证券分析》，如果要把这本书一千页的内容归纳成一句话，就是：</span
          ><span style="font-size: 15px; letter-spacing: 2px"
            >价值投资人要把思考价值作为第一大投资习惯。</span
          >
        </p>
        <p style="">
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >这句话并不是我发明的，而是格雷厄姆最出色的弟子巴菲特所说。1984年，在哥伦比亚大学纪念《证券分析》出版50周年的庆祝活动上，巴菲特发表演讲说：“格雷厄姆和多德写的《证券分析》只关心一件事，就是分析股票的内在价值，特别是股票内在价值与市场价格的差异。”</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >那么价值投资人应该如何思考价值呢？&nbsp;</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p class="title2">
          <span style="font-size: 15px; letter-spacing: 2px"
            >一、思考价值的最佳指南</span
          >
        </p>
        <p><br /></p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >巴菲特给《证券分析》第六版写的序言说：“读了《证券分析》，就不需要再寻找第二条投资道路了。”这句话的意思非常直白，是说，证券分析指出的价值投资之路，是他唯一认可的成功投资之路。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >尽管《证券分析》是1940年出版的，有80多年历史了，但我现在读起来还是常读常新，因为这本书主要讲的是投资基本原则，过时的是知识，不会过时的是常识；过时的是技术，不会过时的是原则。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >我个人认为，《证券分析》是“价值投资第一书”，第一次提出了价值投资的基本框架，也就是价值投资人思考价值的基本框架。格雷厄姆从三个层面给出了思考价值的基本框架，那就是：三个基本原理、三个基本指标、三个基本步骤。&nbsp;</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p class="title2">
          <span style="font-size: 15px; letter-spacing: 2px"
            >二、从常识思考价值的三个基本原理</span
          >
        </p>
        <p><span style="font-size: 15px; letter-spacing: 2px"></span></p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >思考价值要坚持“一个中心，两个基本点”，其中一个中心是安全边际，两个基本点是内在价值与市场价格。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >价值投资一个中心是安全边际。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >格雷厄姆说：“如果把投资的秘密概括为四个字，那就是安全边际。”巴菲特说：“安全边际是价值投资永恒的基石。安全边际是什么？就是股票市场价格与内在价值之间的差异。”</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >巴菲特如此描述价值投资：价值投资就是用4毛钱的价格购买一块钱的价值。不过，尽管市场价格明摆在那里，但是股票值多少钱，就是其内在价值是多少，只是投资人自己估算。假设你去商店买东西，却不知道这个东西值多少钱，还想占商店的便宜，你想的美。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >价值投资第一个基本点是内在价值。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >巴菲特说，你要战胜市场先生，就要比市场更懂价值。这也是我们为什么一再强调，价值投资人要把思考价值作为第一大投资习惯，思考股票的价值，其实隐含着第二层意思，就是思考企业的价值。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >格雷厄姆说，价值投资的基本原则之一，要像做企业一样做投资。巴菲特说的更加直截了当：买股票就是买企业。原因很简单，股票其实本质上就是企业的股权凭证。所以，投资思考要以价值为本，价值思考要以企业为本。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >价值投资第二个基本点是市场价格。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >市场价格持续不断地波动，但长期来看是服从价值规律的，以价值水平为中心线，短期内价值上下波动，上下偏离走极端，走到极端又反转。只有相信市场价格波动服从价值规律，才能建立对价值投资的长期信心，才敢于价格过于低估时买入，过于高估时卖出。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >市场波动是投资人的朋友，你比市场更懂价值，才能利用市场先生不理智时低价买入，高价卖出。你一要有识，二要有胆，才能让股票市场成为你的赚钱工具。有人说，很多人想把股市作为自己的提款机，其实大部分人都成了股市的提款机，最大的原因就在于不会正确地思考价值，评估价值。&nbsp;</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p class="title2">
          <span style="font-size: 15px; letter-spacing: 2px"
            >三、从数据思考价值的三个基本指标</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >思考的最高境界是逻辑思考，逻辑思考的最高境界是数字思考，其实数字才是全世界唯一真正的共通语言。巴菲特说，你投入的是价格，你得到的价值。那么价值投资人应该如何思考计算股票的投入产出比呢？</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >买股票就是买企业，我们要像收购企业一样看股票的投入产出比。从收购企业的角度来看，我们的投入是花钱收购所有股票，做企业唯一的大股东，得到的是企业产出的盈利。从股东盈利这个角度，就形成了三个股票估值指标。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >第一个估值指标是股息收益率。用现金给股东分红，才是股东真正拿到手的真金白银，这就是现金股息。每股股息除以每股市场价格，就是股息收益率。这是最早的股票估值指标，其实就是把股票看作永不还本的债券，把股息看作利息，将股息收益率与十年期国债利率对比，如果股息收益率大幅高于国债利率水平，股票就值得投资。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >但是这个指标有个缺点，就是很多公司发放的股息是不稳定的，特别是很多上市公司根本不发放股息。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >投资人也很聪明，知道如何变通。企业是属于股东的，比如企业今年赚了100万，但只给股东现金分红20万，剩下的80万未分配利润属于谁？肯定还是属于股东。所以正确的做法应该是根据企业所有归属于股东的盈利来估值。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >第二个估值指标——市盈率应运而生。你的投入是每股股票的市场价格，得到的是每股收益，投入产出比就是每股市价除以每股收益，一般简称为市盈率。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >假如我买的股票每股价格100块钱，企业每年能赚到每股收益是5块钱，市盈率是每股100块钱的市价除以每股5块钱的盈利，这意味着，企业持续保持每年5块钱每股收益，用20年就可以收回100块钱的投资成本。市盈率20倍代表20年靠盈利收回投资成本，市盈率50倍代表50年靠盈利收回投资成本，你愿意投资市盈率20倍还是50倍的企业？</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >市盈率估值指标本身也有很大的缺点，因为盈利有很多是虚的，后来就出现按照折现现金流量估值的方法，企业财务报表也多了一个现金流量表。巴菲特认为，企业的自由现金流量，即企业的现金净流量扣除维护其竞争优势的资本支出，折现出来的价值，是最正确的估值方法。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >第三个估值指标，也是格雷厄姆当年用的最多，给他赚钱最多的指标，即市净率。市净率是一个非常简单的估值指标，净是资产净值的意思，根据企业的资产变现价值扣除所有负债之后完全属于股东的净值来估值。简单地说，就是假设企业要倒闭了，把所有资产清算拍卖，还掉负债之后，剩下来属于股东的资产净值是多少。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >如果每股资产净值大大超过每股市场价格，这样的股票肯定太便宜了。格雷厄姆当年在计算资产净值时甚至根本不计入企业的无形资产和固定资产，只看流动资产和现金资产的价值。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >当年格雷厄姆和巴菲特靠现金资产净值这么简单的一招就赚到了大钱。1926年，格雷厄姆发现北方管道公司每股股价65美元，但公司账上的铁路债券就价值每股95美元。后来北方管道公司向股东每股分红70美元，让格雷厄姆赚了大钱。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >1958年，桑伯恩地图公司股票市场价格是是每股45美元，但只是公司持有的股票和债券就价值每股65美元，后来公司把大部分证券变现，让巴菲特赚了大钱。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >巴菲特说，现在遍地都是股票投资人和投资机构，当年格雷厄姆带着他们几个年轻人，用那么简单的估值指标，就能找到很多便宜股票的投资时代，早就一去不复返了。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >会过时的是具体指标，不会过时的是基本原则。巴菲特一直在不断进步，他的估值技术不断与时俱进，但是投资原则始终不变，还是格雷厄姆提出的价值投资基本原则。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >我们思考了格雷厄姆提出的价值投资的基本原理，一个中心两个基本点，也思考了格雷厄姆价值投资的三个基本估值指标，那么具体投资操作中如何运用呢？</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p class="title2">
          <span style="font-size: 15px; letter-spacing: 2px"
            >&nbsp;四、从操作思考价值的三个基本步骤</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >再好的想法，再好的计划，要转化成每天容易执行的操作步骤，才能真正落到实处。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >格雷厄姆是价值投资的鼻祖，也是证券分析行业的祖师爷，他在《证券分析》第七部分提出了证券分析的基本步骤，整个证券分析行业沿用至今。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >第一个步骤是行业比较分析。主要是根据三个估值指标等定量分析指标，分析比较同一行业各家上市公司股票的估值水平，迅速找出明显低于行业平均估值水平的少数企业个股。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >第二个步骤是企业深度分析。对企业进行深度分析，以定性分析为主，确定企业业务发展是否具有稳定性，正常盈利能力是否稳定可靠，市盈率倍数是否合理，最终才能确认其股价真正属于过于低估。股价低估的定量分析结论，建立在对企业盈利能力的定性评估上。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >第三个步骤是股价回归分析。不同个股，其市场价格回归价值的速度，即市场敏感性差别很大，大盘股明显强于中小盘股，一线知名行业龙头股明显强于二线三线股，热门题材股明显强于没有题材的冷门股。格雷厄姆说要综合考虑股价估值水平和市场敏感性，并结合个人的投资能力来决定如何选择。业余投资人尽量只选择著名的大盘龙头股，专业投资人可以选择没有知名度但估值便宜得多的多的二线三线中小盘股。但是无论专业投资人还是业余投资人，只要是价值投资人，都要远离那些热门题材股。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p class="title2">
          <span style="font-size: 15px; letter-spacing: 2px"
            >&nbsp;五、要思考价值，不要思考价格</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >以上就是《证券分析》的核心内容，教你思考价值投资的三个基本原理、三个基本估值指标、三个基本分析步骤，最终把思考价值成为第一大投资习惯。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >巴菲特运用价值投资原则来管理投资，为伯克希尔创造出巨大的盈利增长，使其股价在过去56年内累计上涨了2万8千倍。</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >巴菲特说：“我们的成功是格雷厄姆和多德在《证券分析》中价值投资智慧结出的果实。”</span
          >
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"><br /></span>
        </p>
        <p>
          <span style="font-size: 15px; letter-spacing: 2px"
            >希望更多的朋友愿意像巴菲特一样精读《证券分析》，把思考价值作为第一大投资习惯，坚定走上少有人走的价值投资之路，在实践中不断进化，最终成为长期战胜市场的少数投资人。</span
          >
        </p>
        <p style=""><br /></p>
        
        <p class="free">（来源：陆家嘴传媒）</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.zhemo{
    text-align: center;
    padding: 30px;
    font-weight: bold;
     color: #6f6f6f!important;
}
.title2{
    font-weight: bold;
    line-height: 30px;
}
p,span{
    text-indent: 2em;
    font-size: 14px!important;
    color: #6f6f6f!important;
    letter-spacing: 0!important;
}
</style>